import { Accessor, JSX, Show, createMemo } from 'solid-js';
import createKeepAlive from '@/hooks/createKeepAlive';

export interface ToggleProps<T> {
  when: T | undefined | null | false;
  fallback?: JSX.Element;
  children: JSX.Element;
  /** 启用缓存, 默认为启用 */
  keepAlive?: boolean;
}

/**
 * 这是一个带缓存的Toggle组件，可以用来替换Show，但是他的children只会创建一次，用于做性能优化。
 * 如果使用过vue的话，应该了解他keep-alive的功能，这里思想是一样的
 * 注意: keepAlive属性并不参与响应，他更像是一个常量
 * @param props 和Show签名类似，未实现keyed逻辑
 * @returns
 */
export function Toggle<T>(props: ToggleProps<T>) {
  let render: RenderType = (el) => el();
  let renderFallback = render;
  if (props.keepAlive !== false) {
    render = createKeepAlive();
    renderFallback = createKeepAlive();
  }
  const when = createMemo(() => Boolean(props.when));

  return (
    <Show
      when={when()}
      fallback={renderFallback(
        () => props.fallback,
        () => !when()
      )}
    >
      {render(
        () => props.children,
        () => when()
      )}
    </Show>
  );
}

type RenderType = (
  el: () => JSX.Element,
  active: Accessor<boolean>
) => JSX.Element;
